import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DOMAIN_TRIAL_ROUTE_FULL_PATH } from '../constants/app-routes.constant';

export const DEMO_REQUEST_KEY_STORAGE = 'is_trial_request';
export const DOMAIN_TRIAL_PATH = 'domain_trial_path';

@Injectable({
  providedIn: 'root',
})
export class TrialPeriodService {
  constructor(private readonly _router: Router) {}

  demoRequest() {
    localStorage.setItem(DEMO_REQUEST_KEY_STORAGE, 'true');
  }

  get isTrialRequest(): boolean {
    return !!localStorage.getItem(DEMO_REQUEST_KEY_STORAGE);
  }

  get createDomainFromPartnerPath(): string | null {
    return sessionStorage.getItem(DOMAIN_TRIAL_PATH);
  }

  clear() {
    localStorage.removeItem(DEMO_REQUEST_KEY_STORAGE);
    sessionStorage.removeItem(DOMAIN_TRIAL_PATH);
  }
}

export function initializeTrialPeriodFactory(
  _router: Router,
  trialPeriodService: TrialPeriodService,
): () => Promise<void> {
  return async () =>
    new Promise((resolve) => {
      _router.events.subscribe((event) => {
        if (event instanceof NavigationStart && event.url.includes(DOMAIN_TRIAL_ROUTE_FULL_PATH)) {
          sessionStorage.setItem(DOMAIN_TRIAL_PATH, event.url);
          trialPeriodService.demoRequest();
        }
      });
      resolve();
    });
}
